(function () {
  var d = document, w = window, root = d.documentElement;
  var RM = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = null;
  function reveal(scope) {
    var els = (scope || d).querySelectorAll('[data-r]:not(.in),.f-lines:not(.in)');
    if (RM || !('IntersectionObserver' in w)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    if (!obs) obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { obs.observe(e); });
  }
  var px = [], hs = [], heroes = [], ticking = false;
  function wide() { return w.innerWidth >= 990 && !RM; }
  function collect() { px = [].slice.call(d.querySelectorAll('[data-px]')); hs = [].slice.call(d.querySelectorAll('[data-hs]')); heroes = [].slice.call(d.querySelectorAll('[data-hero]')); sizeHS(); }
  function sizeHS() {
    hs.forEach(function (s) {
      var t = s.querySelector('[data-hs-track]'); if (!t) return;
      if (wide()) { var extra = t.scrollWidth - w.innerWidth; s.style.height = (w.innerHeight + Math.max(0, extra)) + 'px'; s.classList.add('is-pinned'); }
      else { s.style.height = ''; t.style.transform = ''; s.classList.remove('is-pinned'); }
    });
  }
  function frame() {
    ticking = false;
    var vh = w.innerHeight;
    if (!RM) px.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
      var sp = parseFloat(el.getAttribute('data-px')) || 0.1;
      el.style.transform = 'translate3d(0,' + (p * sp * r.height * -2).toFixed(1) + 'px,0) scale(' + (1 + sp * 2.2).toFixed(3) + ')';
    });
    if (wide()) hs.forEach(function (s) {
      var t = s.querySelector('[data-hs-track]'); if (!t) return;
      var r = s.getBoundingClientRect(), max = s.offsetHeight - vh;
      var p = Math.min(1, Math.max(0, -r.top / (max || 1)));
      t.style.transform = 'translate3d(' + (-p * (t.scrollWidth - w.innerWidth)).toFixed(1) + 'px,0,0)';
      var bar = s.querySelector('[data-hs-bar]'); if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    });
    if (!RM) heroes.forEach(function (h) {
      var r = h.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      h.style.setProperty('--hs', (1 + Math.min(1, Math.max(0, -r.top / r.height)) * 0.04).toFixed(4));
    });
    var y = w.scrollY || w.pageYOffset;
    root.classList.toggle('f-scrolled', y > 40);
    var st = d.querySelector('.f-sticky'); if (st) st.classList.toggle('on', y > vh * 0.85);
  }
  function onScroll() { if (!ticking) { ticking = true; w.requestAnimationFrame(frame); } }
  function money(c) {
    try { return (c / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }); }
    catch (e) { return '₹' + (c / 100); }
  }
  function flavours(scope) {
    (scope || d).querySelectorAll('[data-flv]').forEach(function (rootEl) {
      if (rootEl.__f) return; rootEl.__f = 1;
      var btns = [].slice.call(rootEl.querySelectorAll('[data-flv-btn]'));
      function pick(i, focus) {
        rootEl.querySelectorAll('[data-flv-i]').forEach(function (el) {
          var on = el.getAttribute('data-flv-i') === String(i);
          el.classList.toggle('on', on);
          if (el.hasAttribute('data-flv-panel')) el.hidden = !on;
          if (on && el.hasAttribute('data-tint')) rootEl.style.setProperty('--tint', el.getAttribute('data-tint'));
        });
        btns.forEach(function (b) {
          var on = b.getAttribute('data-flv-btn') === String(i);
          b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
          if (on && focus) b.focus();
        });
      }
      rootEl.addEventListener('click', function (e) { var b = e.target.closest('[data-flv-btn]'); if (b) pick(b.getAttribute('data-flv-btn')); });
      rootEl.addEventListener('keydown', function (e) {
        var b = e.target.closest('[data-flv-btn]'); if (!b) return;
        var i = btns.indexOf(b), n = btns.length;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); pick(btns[(i + 1) % n].getAttribute('data-flv-btn'), true); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); pick(btns[(i - 1 + n) % n].getAttribute('data-flv-btn'), true); }
      });
    });
  }
  function sizes(scope) {
    (scope || d).querySelectorAll('form[data-f-add]').forEach(function (f) {
      if (f.__s) return; f.__s = 1;
      f.addEventListener('change', function (e) {
        var t = e.target; if (t.name !== 'id' || !t.dataset.price) return;
        var p = f.querySelector('[data-f-price]'), c = f.querySelector('[data-f-compare]');
        if (p) p.textContent = money(+t.dataset.price);
        if (c) { var cp = +t.dataset.compare || 0; c.textContent = cp > +t.dataset.price ? money(cp) : ''; }
      });
    });
  }
  var toastT;
  function toast(msg) {
    var t = d.querySelector('.f-toast');
    if (!t) { t = d.createElement('div'); t.className = 'f-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); d.body.appendChild(t); }
    t.innerHTML = '<span></span><a href="/cart">View bag</a>'; t.firstChild.textContent = msg;
    t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 3600);
  }
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-f-add]') || !w.fetch) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'), label = b ? b.innerHTML : '';
    if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); }
    var base = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (item) {
        return fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          d.querySelectorAll('[data-f-count]').forEach(function (n) { n.textContent = cart.item_count; }); d.querySelectorAll('.f-sticky').forEach(function (s) { s.classList.toggle('has-items', cart.item_count > 0); var a = s.querySelector('a.f-btn'); if (a && cart.item_count > 0) { a.href = '/cart'; a.textContent = 'View bag'; } });
          try { d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'farmelo', data: { source: 'farmelo', itemCount: cart.item_count, productId: item.product_id } } })); } catch (x) {}
          if (b) { b.innerHTML = '<span>Added</span>'; setTimeout(function () { b.innerHTML = label; b.disabled = false; b.removeAttribute('aria-busy'); }, 1600); }
          toast((item.product_title || 'Item') + ' — added to your bag');
        });
      })
      .catch(function () { if (b) { b.disabled = false; b.removeAttribute('aria-busy'); } f.removeAttribute('data-f-add'); f.submit(); });
  });
  function peek(scope) {
    (scope || d).querySelectorAll('[data-peek]').forEach(function (list) {
      if (list.__p) return; list.__p = 1;
      var pv = list.querySelector('[data-peek-view]');
      if (!pv || !w.matchMedia('(hover: hover)').matches) return;
      var img = pv.querySelector('img');
      list.addEventListener('mousemove', function (e) { var r = list.getBoundingClientRect(); pv.style.transform = 'translate3d(' + (e.clientX - r.left) + 'px,' + (e.clientY - r.top) + 'px,0)'; });
      list.querySelectorAll('[data-peek-src]').forEach(function (row) {
        row.addEventListener('mouseenter', function () { var s = row.getAttribute('data-peek-src'); if (s && img.getAttribute('src') !== s) img.src = s; pv.classList.toggle('on', !!s); });
        row.addEventListener('mouseleave', function () { pv.classList.remove('on'); });
      });
    });
  }
  var vobs = null;
  function videos(scope) {
    (scope || d).querySelectorAll('video.f-video').forEach(function (v) {
      if (v.__v) return; v.__v = 1;
      v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.removeAttribute('controls');
      if (RM) { v.removeAttribute('autoplay'); v.pause(); return; }
      if (!('IntersectionObserver' in w)) return;
      if (!vobs) vobs = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } else e.target.pause(); }); }, { threshold: 0.05 });
      vobs.observe(v);
    });
  }
  function slides(scope) {
    (scope || d).querySelectorAll('[data-slides]').forEach(function (r) {
      if (r.__sl) return; r.__sl = 1;
      var s = [].slice.call(r.querySelectorAll('[data-slide]'));
      var host = r.closest('section') || r.parentNode;
      var dots = [].slice.call(host.querySelectorAll('[data-slide-dot]'));
      if (s.length < 2) return;
      var i = 0, ms = parseInt(r.getAttribute('data-slides'), 10) || 6000, t = null;
      function go(n) {
        if (n === i) return;
        s[i].classList.remove('on'); if (dots[i]) dots[i].classList.remove('on');
        i = n; s[i].classList.add('on'); if (dots[i]) dots[i].classList.add('on');
        var v = s[i].querySelector('video'); if (v) { try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
      }
      function restart() { clearInterval(t); if (!RM) t = setInterval(function () { go((i + 1) % s.length); }, ms); }
      dots.forEach(function (dt, k) { dt.addEventListener('click', function () { go(k); restart(); }); });
      restart();
    });
  }
  function glow(scope) {
    if (!w.matchMedia('(hover: hover)').matches) return;
    (scope || d).querySelectorAll('[data-glow]').forEach(function (el) {
      if (el.__g) return; el.__g = 1;
      el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); el.style.setProperty('--gx', (e.clientX - r.left).toFixed(1) + 'px'); el.style.setProperty('--gy', (e.clientY - r.top).toFixed(1) + 'px'); });
    });
  }
  function hero(scope) {
    if (RM || !w.matchMedia('(hover: hover)').matches) return;
    (scope || d).querySelectorAll('[data-hero]').forEach(function (h) {
      if (h.__h) return; h.__h = 1;
      var f = h.querySelector('.f2-hero__float'); if (!f) return;
      h.addEventListener('pointermove', function (e) { var r = h.getBoundingClientRect(); f.style.setProperty('--mx', (((e.clientX - r.left) / r.width - 0.5) * -8).toFixed(1) + 'px'); f.style.setProperty('--my', (((e.clientY - r.top) / r.height - 0.5) * -6).toFixed(1) + 'px'); });
      h.addEventListener('pointerleave', function () { f.style.setProperty('--mx', '0px'); f.style.setProperty('--my', '0px'); });
    });
  }
  function marquee() {
    if (RM) return;
    d.querySelectorAll('.announcement-bar').forEach(function (bar) {
      if (bar.__m) return;
      var t = [].map.call(bar.querySelectorAll('.announcement-bar__text'), function (p) { return p.textContent.trim(); }).filter(Boolean);
      if (!t.length) return; bar.__m = 1;
      var m = d.createElement('div'); m.className = 'f-marq'; m.setAttribute('aria-hidden', 'true');
      var tr = d.createElement('div'); tr.className = 'f-marq__track';
      for (var k = 0; k < 8; k++) t.forEach(function (s) { var i = d.createElement('span'); i.className = 'f-marq__item'; i.textContent = s; tr.appendChild(i); });
      m.appendChild(tr); bar.appendChild(m); bar.classList.add('f-marq-on');
      tr.style.animationDuration = Math.max(30, tr.scrollWidth / 2 / 45).toFixed(1) + 's';
    });
  }
  function pdp(scope) {
    (scope || d).querySelectorAll('[data-pdp]').forEach(function (r) {
      if (r.__pd) return; r.__pd = 1;
      var f = r.querySelector('[data-pdp-form]'); if (!f) return;
      var q = r.querySelector('[data-pdp-q]'), id = r.querySelector('[data-pdp-id]');
      var add = r.querySelector('[data-pdp-add]'), buy = r.querySelector('[data-pdp-buy]');
      if (add) add.addEventListener('click', function () { f.setAttribute('data-f-add', ''); });
      if (buy) buy.addEventListener('click', function () { f.removeAttribute('data-f-add'); });
      r.querySelectorAll('[data-pdp-qty]').forEach(function (b) { b.addEventListener('click', function () { var n = Math.min(20, Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-pdp-qty'), 10))); q.value = n; }); });
      r.querySelectorAll('[data-pdp-v]').forEach(function (b) {
        b.addEventListener('click', function () {
          r.querySelectorAll('[data-pdp-v]').forEach(function (o) { var on = o === b; o.classList.toggle('on', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
          id.value = b.getAttribute('data-pdp-v');
          var pr = +b.dataset.price, cp = +b.dataset.compare || 0, off = cp > pr ? Math.floor((cp - pr) * 100 / cp) : 0;
          var set = function (sel, t) { var e = r.querySelector(sel); if (e) e.textContent = t; };
          set('[data-pdp-price]', money(pr)); set('[data-pdp-compare]', money(cp)); set('[data-pdp-off]', '(' + off + '% off)'); set('[data-pdp-vlabel]', b.dataset.title); set('[data-pdp-flag]', off + '% off');
          var m = r.querySelector('[data-pdp-mrp]'); if (m) m.hidden = !off;
          var fl = r.querySelector('[data-pdp-flag]'); if (fl) fl.hidden = !off;
          var ok = b.dataset.available === 'true';
          if (add) { add.disabled = !ok; add.innerHTML = '<span>' + (ok ? 'Add to bag' : 'Sold out') + '</span>'; }
          if (buy) buy.disabled = !ok;
          try { var u = new URL(w.location.href); u.searchParams.set('variant', id.value); w.history.replaceState({}, '', u); } catch (e) {}
        });
      });
      var pin = r.querySelector('[data-pdp-pin]'), msg = r.querySelector('[data-pdp-pinmsg]'), chk = r.querySelector('[data-pdp-check]');
      function check() {
        var v = (pin.value || '').replace(/\D/g, '');
        if (!/^[1-9][0-9]{5}$/.test(v)) { msg.textContent = 'Please enter a valid 6-digit pincode.'; msg.className = 'f2-pdp__pinmsg is-err'; return; }
        msg.textContent = 'Delivers to ' + v + ' in ' + r.getAttribute('data-days') + ' days.'; msg.className = 'f2-pdp__pinmsg is-ok';
      }
      if (chk) { chk.addEventListener('click', check); pin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } }); pin.addEventListener('input', function () { pin.value = pin.value.replace(/\D/g, '').slice(0, 6); }); }
      var main = r.querySelector('[data-pdp-main]');
      r.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.addEventListener('click', function () { if (!main) return; main.removeAttribute('srcset'); main.src = t.getAttribute('data-pdp-thumb'); r.querySelectorAll('[data-pdp-thumb]').forEach(function (o) { o.classList.toggle('on', o === t); }); }); });
    });
  }
  function init(scope) { reveal(scope); flavours(scope); sizes(scope); peek(scope); videos(scope); slides(scope); glow(scope); hero(scope); pdp(scope); marquee(); collect(); frame(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', function () { sizeHS(); onScroll(); });
  w.addEventListener('load', function () { sizeHS(); onScroll(); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
